export default __webpack_public_path__ + "static/throttle-vs-debounce-cf4b085bfd89845052beaf9c552bb884.svg";